export const USER_ROLES = {
    SUPERADMIN: 'superadmin',
    ADMIN: 'admin',
    SHOPKEEPER: 'shopkeeper',
    AGENT: 'agent',
};
export const ORDER_STATUS = {
    PENDING: 'PENDING',
    PRINTING: 'PRINTING',
    COMPLETED: 'COMPLETED',
    EXPIRED: 'EXPIRED',
    CANCELLED: 'CANCELLED',
    ARCHIVED: 'ARCHIVED',
};
export const FILE_ROUTE_TYPE = {
    DIRECT: 'DIRECT',
    MANUAL: 'MANUAL',
};
export const FILE_STATUS = {
    ACTIVE: 'ACTIVE',
    REVOKED: 'REVOKED',
    PRINTED: 'PRINTED',
    PRINTING: 'PRINTING',
};
export const ORDER_PRINT_STATUS = {
    NONE: 'NONE',
    PRINTING: 'PRINTING',
    PRINT_DONE: 'PRINT_DONE',
    PARTIAL_DONE: 'PARTIAL_DONE',
    FAILED: 'FAILED',
};
export const CACHE_STATE = {
    NONE: 'NONE',
    DOWNLOADING: 'DOWNLOADING',
    CACHED: 'CACHED',
    FAILED: 'FAILED',
};
export const PRINT_ACTION = {
    PRINT: 'PRINT',
    SEND_TO_DESKTOP: 'SEND_TO_DESKTOP',
    CANCEL: 'CANCEL',
};
export const PRINT_JOB_STATUS = {
    QUEUED: 'QUEUED',
    PRINTING: 'PRINTING',
    DONE: 'DONE',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
};
export const SUBSCRIPTION_STATUS = {
    ACTIVE: 'ACTIVE',
    GRACE: 'GRACE',
    EXPIRED: 'EXPIRED',
    SUSPENDED: 'SUSPENDED',
};
export const COLOR_MODE = {
    BW: 'BW',
    COLOR: 'COLOR',
};
// System limits & defaults
export const MAX_MESSAGE_LENGTH = 1000;
export const DEFAULT_TOP_CACHE_SIZE = 10;
export const DEFAULT_ORDER_EXPIRY_HOURS = 23;
export const DEFAULT_DETAIL_LOG_DAYS = 2;
export const DEFAULT_FINISHED_ORDER_RETENTION_DAYS = 2;
export const DEFAULT_GRACE_DAYS = 3;
export const DEFAULT_DISK_CAP_GB = 180;
export const DEFAULT_BURST_DEBOUNCE_MS = 8000;
export const DIRECT_PRINT_EXTENSIONS = ['.pdf'];
export const ALLOWED_PLACEHOLDERS = [
    '{{phone}}',
    '{{orderId}}',
    '{{queueNumber}}',
    '{{fileCount}}',
    '{{customerName}}',
    '{{queueIndex}}',
    '{{totalPages}}',
    '{{totalPrice}}',
    '{{customersAhead}}',
    '{{customersAheadText}}',
    '{{queuePosition}}',
    '{{shopName}}',
];
export const DEFAULT_MESSAGES = {
    welcomeMessage: 'Welcome to {{shopName}}! 🖨️ Please send your PDF for direct printing, or any other document/image (Word, Excel, PowerPoint, Photos) to be downloaded for manual printing.',
    orderReceived: 'Your {{fileCount}} file(s) collected! {{customersAheadText}} We will notify you when printing begins.',
    printingConfirmation: 'Your {{fileCount}} file(s) have finished printing! Please collect them from the counter.',
    expiryNotice: 'Notice: Your files have been automatically cleared from the queue due to inactivity to protect privacy. Please resend if you still need them printed.',
};
export const MANUAL_BADGE_TEMPLATE = (extension) => `Non-PDF format detected (${extension}). Downloaded to Desktop/Manual_Print for manual print.`;
//# sourceMappingURL=constants.js.map